// extracted by mini-css-extract-plugin
export default {"fixedSidebar":"RpdXoJ"};